import React from "react"
import CountUp from "react-countup"
import VisibilitySensor from "react-visibility-sensor"

export default function Stat({ prefix, suffix, number, unit, note }) {
  return (
    <div className="stat" key={`stat${Math.random()}`}>
      <CountUp end={number} prefix={prefix} suffix={suffix} separator=",">
        {({ countUpRef, start }) => (
          <VisibilitySensor onChange={start} delayedCall>
            <div className="stat__number" ref={countUpRef} />
          </VisibilitySensor>
        )}
      </CountUp>

      {unit ? <div className="stat__unit">{unit}</div> : null}
      {note ? <div className="stat__note">{note}</div> : null}
    </div>
  )
}
